import React, {Component} from "react"
import PropTypes from "prop-types"
import {cloneDeep} from "lodash"

import id from "@irati/utils/id"
import Button from "@irati/ui/src/Button"
import Loading from "@irati/ui/src/Loading"
import notify from "@irati/utils/notify"
import {updateSurvey} from "@irati/insights/services/survey"
import {STATUS_OPEN} from "@irati/insights/constants/survey"

const _SUCCESS_MESSAGE = "Your survey has been started"

class ButtonListActions extends Component {
  static propTypes = {
    onUpdate: PropTypes.func.isRequired
  }
  static defaultProps = {}

  constructor(props) {
    super(props)
    this.state = {}
  }

  handleClick(survey) {
    const surveyCopy = cloneDeep(survey)
    surveyCopy.status = STATUS_OPEN
    const load = updateSurvey(surveyCopy).then(() => {
      notify.success({message: _SUCCESS_MESSAGE, position: "bottom-right"})
      this.props.onUpdate()
    })
    this.setState({load})
  }

  render() {
    const idNamespace = id("button-list-actions", this.props)
    return (
      <Loading id={idNamespace} load={this.state.load}>
        <Button onClick={this.toggleModal}>Start Test Survey </Button>

        {/* @todo going to get rid of modal and move to inline */}
      </Loading>
    )
  }
}

export default ButtonListActions
